export const XBIT_RELAY_REBALANCES_PERMISSION_RESOURCE = 'xbit-relay:rebalances';
export const XBIT_RELAY_REBALANCES_READ_ACTION = 'read';
export const XBIT_RELAY_REBALANCES_APPROVE_ACTION = 'approve';
export const XBIT_RELAY_REBALANCES_REJECT_ACTION = 'reject';
export const XBIT_RELAY_REBALANCES_RESOLVE_ACTION = 'resolve';

/** The only two values `/resolve` accepts — anything else is a 400. */
export const REBALANCE_RESOLUTIONS = ['DONE', 'FAILED'] as const;

/**
 * The lifecycle wallet-service drives a rebalance through. `status` is still a free string on the
 * wire, so this list only drives the filter dropdown and the row-action rules — an unknown value
 * is always rendered as-is rather than crashing on a missing map entry.
 */
export const REBALANCE_STATUSES = [
  'PROPOSED',
  'APPROVED',
  'SIGNED',
  'BROADCAST_SRC',
  'RELAY_PENDING',
  'CONFIRMED_DST',
  'DONE',
  'REJECTED',
  'FAILED',
  'STUCK',
] as const;

/**
 * A rebalance is approvable/rejectable only while it sits here.
 *
 * `PROPOSED` is the real lifecycle value; `PENDING` is kept as an alias because the API docs
 * show `"status": "PENDING"` in the `/rebalances/pending` example. Accepting both means the
 * action buttons appear either way instead of silently never rendering.
 */
export const REBALANCE_APPROVABLE_STATUSES = ['PROPOSED', 'PENDING'] as const;

/** Closed out — no action left. Everything else in the lifecycle is in flight, `STUCK` included. */
export const REBALANCE_TERMINAL_STATUSES = ['DONE', 'REJECTED', 'FAILED'] as const;

// BE caps pageSize at 200.
export const REBALANCE_ROWS_PER_PAGE = [10, 20, 50, 100, 200];
